import { LogLevel } from './log-level.js';

export class Logger {
	private _namespace: string;
	private _level: LogLevel = LogLevel.debug;

	constructor(namespace?: string) {
		this._namespace = namespace ? namespace : 'default';
	}

	public log(msg: unknown, ...params: unknown[]): void {
		msg = this.formatMessage(msg);
		if (this._level <= LogLevel.debug) {
			this.logToConsole(console.log, msg, ...params);
		}
	}

	public info(msg: unknown, ...params: unknown[]): void {
		msg = this.formatMessage(msg);
		if (this._level <= LogLevel.info) {
			this.logToConsole(console.log, msg, ...params);
		}
	}

	public warn(msg: unknown, ...params: unknown[]): void {
		msg = this.formatMessage(msg);
		if (this._level <= LogLevel.warn) {
			this.logToConsole(console.warn, msg, ...params);
		}
	}

	public error(error: unknown, ...params: unknown[]): void {
		const msg = this.formatMessage(error);

		if (this._level <= LogLevel.error) {
			this.logToConsole(console.error, msg, ...params);
		}
	}

	private formatMessage(msgObj: unknown): string {
		const msgStr =
			typeof msgObj === 'string'
				? msgObj
				: this.formatMessage(JSON.stringify(msgObj));
		return `${new Date()} - ${this._namespace} - ${msgStr}`;
	}

	private logToConsole(
		consoleFunc: (msg: unknown, params?: unknown[]) => void,
		msg: unknown,
		...params: unknown[]
	): void {
		if (params?.length === 0) {
			consoleFunc(msg);
		} else {
			consoleFunc(msg, params);
		}
	}
}
